import { render, staticRenderFns } from "./DnaTraitScoresCard.vue?vue&type=template&id=10184c34&"
import script from "./DnaTraitScoresCard.vue?vue&type=script&lang=js&"
export * from "./DnaTraitScoresCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports